import type { App } from 'vue'
import Tooltip from 'primevue/tooltip'

export const registerNabooDirectives = (app: App) => {
  app.directive('tooltip', Tooltip)
}

